import { render } from "./Compliance.vue?vue&type=template&id=33ffe111&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"

import "./Compliance.vue?vue&type=style&index=0&id=33ffe111&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ffe111"]])

export default __exports__